import { render, staticRenderFns } from "./outpatientChargeStatistics.vue?vue&type=template&id=2ebe89e4&scoped=true"
import script from "./outpatientChargeStatistics.vue?vue&type=script&lang=js"
export * from "./outpatientChargeStatistics.vue?vue&type=script&lang=js"
import style0 from "./outpatientChargeStatistics.vue?vue&type=style&index=0&id=2ebe89e4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebe89e4",
  null
  
)

export default component.exports